import { determineBackgroundClass } from "./determineBackgroundClass"
import { StatusVariant } from "./StatusVariant"
import { statusVariantTokens } from "./statusVariantTokens"

/**
 * Determine the subdued background class for a status variant.
 * Used for low-emphasis treatments (e.g., alert backgrounds, notification backgrounds).
 */
export function determineStatusBackgroundSubduedClass(variant: StatusVariant): string {
  return determineBackgroundClass(statusVariantTokens[variant].backgroundSubdued)
}
